import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Icon,
  Typography,
} from '@mui/material';
import { Category } from '../../api/blogs';
import { KENNISBANK_CATEGORY_ITEM_ROUTE } from '../../pages/routes';
import React from 'react';
import NextLink from 'next/link';
import AppLink from '../Link/AppLink';
import { HighLightedText } from '../HighLightedText/HighLightedText';

interface CategoryCardProps {
  category: Category;
}

export function CategoryCard(props: CategoryCardProps) {
  const { category } = props;
  const categoryLink = KENNISBANK_CATEGORY_ITEM_ROUTE + category.slug;
  const restricted = category.restricted;

  return (
    <>
      {!restricted ? (
        <NextLink passHref as={categoryLink} href={categoryLink}>
          <Card
            sx={{
              '&:hover': {
                cursor: 'pointer',
                opacity: 0.8,
              },
            }}
          >
            <CardContent>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  textAlign: 'center',
                  alignItems: 'center',
                }}
              >
                <Icon sx={{ fontSize: '10rem', mb: 2 }}>{category.icon}</Icon>
                <HighLightedText
                  text={category.name}
                  TypographyProps={{
                    color: 'secondary.main',
                    variant: 'h5',
                    fontWeight: 600,
                  }}
                />
              </Box>
            </CardContent>
            <CardContent sx={{ pt: 1, pb: 1, minHeight: 200 }}>
              <Typography paragraph align={'center'}>
                {category.description}
              </Typography>
            </CardContent>
            <CardActions sx={{ p: 2, pt: 0, width: '100%' }}>
              <Button
                fullWidth
                variant={'contained'}
                component={AppLink}
                href={categoryLink}
              >
                Bekijken
              </Button>
            </CardActions>
          </Card>
        </NextLink>
      ) : (
        <Card>
          <CardContent>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Icon sx={{ fontSize: '10rem', mb: 2 }}>{category.icon}</Icon>
              <HighLightedText
                text={category.name}
                TypographyProps={{
                  color: 'secondary.main',
                  variant: 'h5',
                  fontWeight: 600,
                }}
              />
            </Box>
          </CardContent>
          <CardContent sx={{ pt: 1, pb: 1, minHeight: 200 }}>
            <Typography paragraph align={'center'}>
              {category.description}
            </Typography>
          </CardContent>
          <CardActions sx={{ p: 2, pt: 0, width: '100%' }}>
            <Button
              disabled
              fullWidth
              variant={'contained'}
              component={AppLink}
              href={categoryLink}
            >
              Binnenkort
            </Button>
          </CardActions>
        </Card>
      )}
    </>
  );
}
